import styles from './AccuracyProgressBar.module.scss';

const AccuracyProgressBar = ({ accuracy, className }) => {
    // Get accuracy color based on percentage
    const getAccuracyColor = (accuracy) => {
        if (accuracy === 0) return '#9ca3af'; // Grey for no practice (0%)
        if (accuracy >= 80) return '#22c55e'; // Green for excellent (80-100%)
        if (accuracy >= 60) return '#eab308'; // Yellow for good (60-79%)
        return '#ef4444'; // Red for needs improvement (1-59%)
    };

    // Get bland background color (20% opacity)
    const getBlandBackgroundColor = (accuracy) => {
        if (accuracy === 0) return 'rgba(156, 163, 175, 0.2)'; // Grey with opacity
        if (accuracy >= 80) return 'rgba(34, 197, 94, 0.2)'; // Green with opacity
        if (accuracy >= 60) return 'rgba(234, 179, 8, 0.2)'; // Yellow with opacity
        return 'rgba(239, 68, 68, 0.2)'; // Red with opacity
    };

    const progressColor = getAccuracyColor(accuracy);
    const backgroundBlandColor = getBlandBackgroundColor(accuracy);

    // Circular progress vars
    const radius = 28;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference * (1 - (accuracy || 0) / 100);

    return (
        <div className={`${styles.progressWrapper} ${className || ''}`}>
            {/* Linear bar — large screens */}
            <div className={styles.progressContainer}>
                <div className={styles.progressTrack}>
                    <div
                        className={styles.progressFill}
                        style={{
                            width: `${accuracy}%`,
                            backgroundColor: progressColor
                        }}
                    />
                </div>
                <div
                    className={styles.percentageContainer}
                    style={{
                        backgroundColor: backgroundBlandColor,
                        color: progressColor
                    }}
                >
                    {accuracy}%
                </div>
            </div>

            {/* Circular badge — compact screens */}
            <div className={styles.circularContainer}>
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle
                        cx="32" cy="32" r={radius}
                        stroke={backgroundBlandColor}
                        strokeWidth="5"
                        fill="none"
                    />
                    <circle
                        cx="32" cy="32" r={radius}
                        stroke={progressColor}
                        strokeWidth="5"
                        fill="none"
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                        style={{
                            transform: 'rotate(-90deg)',
                            transformOrigin: '32px 32px',
                            transition: 'stroke-dashoffset 0.3s ease'
                        }}
                    />
                    <text
                        x="32" y="32"
                        textAnchor="middle"
                        dominantBaseline="central"
                        fill={progressColor}
                        fontSize="12"
                        fontWeight="700"
                    >
                        {accuracy}%
                    </text>
                </svg>
            </div>
        </div>
    );
};

export default AccuracyProgressBar;